package org.multiplatform.kotfolio.domain

import androidx.compose.runtime.Immutable
import org.multiplatform.kotfolio.di.BlogBaseEntity
import org.multiplatform.kotfolio.models.BlogEnum

data class Language(val id: String, val name: String)
data class Topic(val id: String, val name: String, val languageId: String)

@Immutable
data class Blog(
    val index: Int,
    val totalView: String,
    val links: List<Pair<String, String>> = emptyList(),
    /*val links: List<Pair<String, String>> = buildList {
        // Add items here if needed
    },*/
    override val blogEnum: BlogEnum)
    : BlogBaseEntity(blogEnum)

